// angular
//   .module("HeroPRO")
//   .controller("ConfirmLeaveController", ConfirmLeaveController);

/* @ngInject */
export default function ConfirmLeaveController(_$event, $uibModalInstance, cancelLocationChange, $location) {
    const vm = this;

    vm.switch = () => {
        $location.path('/');
        $uibModalInstance.close();
    };

    vm.cancel = () => {
        cancelLocationChange();
        $uibModalInstance.close();
    };
}



// WEBPACK FOOTER //
// ./src/app/modals/confirmLeave/confirmLeaveController.js